import * as React from 'react';
import { FC, memo, ElementType } from 'react';
import get from 'lodash/get';
import Typography, { TypographyProps } from '@mui/material/Typography';
import { useRecordContext } from 'ra-core';
import numeral from 'numeral';

import sanitizeFieldRestProps from './sanitizeFieldRestProps';
import { PublicFieldProps, InjectedFieldProps, fieldPropTypes } from './types';
import bytesToSize from '@/utils/bytesToSize';

const SizeTextField: FC<SizeTextFieldProps> = memo<SizeTextFieldProps>(props => {
    const { className, source, numericSource, emptyText, ...rest } = props;
    const record = useRecordContext(props);
    const value = source && get(record, source);
    const numValue = numericSource && get(record, numericSource);

    let displayText =
      (value != null && typeof value === 'string' ? (value || emptyText)
      : numValue != null && typeof numValue === 'number' ? bytesToSize(numValue)
      : emptyText) as string
    if (displayText !== emptyText) {
      displayText = displayText.toUpperCase().replace(/\d+/, (m) => numeral(m).format('0,0'))
    }

    return (
        <Typography
            component="span"
            variant="body2"
            className={className}
            {...sanitizeFieldRestProps(rest)}
        >
            {(numValue ? displayText : emptyText)}
        </Typography>
    );
});

// what? TypeScript loses the displayName if we don't set it explicitly
SizeTextField.displayName = 'SizeTextField';

SizeTextField.defaultProps = {
    addLabel: true,
};

SizeTextField.propTypes = {
    // @ts-ignore
    ...Typography.propTypes,
    ...fieldPropTypes,
};

export type SizeTextFieldProps =
    PublicFieldProps &
    InjectedFieldProps &
    TypographyProps & {
    // TypographyProps do not expose the component props, see https://github.com/mui-org/material-ui/issues/19512
    component?: ElementType<any>;
    numericSource?: string;
}

export default SizeTextField;
